

import comShowye from '../components/showYe.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { mapState, mapActions } from 'vuex';
export default {
components: { Cell ,comShowye},
data() {
return {
isIcon:require("../../../assets/image/My/jymx.png"),
}
},
computed: {
...mapState({
assetsInfoMap: state => state.userInfo.assetsInfoMap,
isLogin: state => state.isLogin,
})
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Wallet/Wallet.vue